var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4328 25.0205L34.4154 24.9881L34.3967 24.9563L22.5869 4.83601C22.5865 4.83526 22.5861 4.83452 22.5856 4.83377C21.8691 3.60716 20.5243 2.75 19 2.75C17.4489 2.75 16.091 3.58211 15.3599 4.83342C15.3594 4.83428 15.3589 4.83515 15.3584 4.83601L3.54861 24.9563L3.52996 24.9881L3.5125 25.0205C2.82979 26.2884 2.78682 27.8379 3.52867 29.1342C4.30161 30.5428 5.72432 31.25 7.1875 31.25H30.8125C32.2501 31.25 33.6564 30.5195 34.4166 29.1343C35.1585 27.8379 35.1155 26.2884 34.4328 25.0205Z",
    fill: "",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.61e78d41d8f3aadf6bd65130363173f4.svg";
export { ForwardRef as ReactComponent };